export default __webpack_public_path__ + "static/button-evolution-75329faf7e2a2f1d710f6a287cb14ed35643df07d0414feacd1e05208deb01ad.mp4";